import React, { useEffect, useRef, useState } from 'react';
import Input from '../../../components/Inputs/Input/Input';
import findByVin from '../../../api/cars/findByVin';
import { carSummary, isSameVin, vinSearchQuery } from './vinSearch';
import formatNumber from '../../../utils/formatNumber';

const SEARCH_DELAY_MS = 350;

// ÐÐ¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ð¿Ð»Ð°Ð²Ð°ÐµÑ Ð¿Ð¾Ð²ÐµÑÑ ÑÐ»ÐµÐ´ÑÑÑÐ¸Ñ Ð¿Ð¾Ð»ÐµÐ¹: Ð²Ð½ÑÑÑÐ¸ ÑÑÐµÐ¹ÐºÐ¸ ÑÐµÑÐºÐ¸ Ð¾Ð½Ð° ÑÐ°Ð·Ð´Ð²Ð¸Ð³Ð°Ð»Ð° Ð±Ñ ÑÑÑÐ¾ÐºÑ Ð¸ ÑÐ±Ð¸Ð²Ð°Ð»Ð° Ð²ÑÑÐ°Ð²Ð½Ð¸Ð²Ð°Ð½Ð¸Ðµ.
const box = {
  position: 'absolute',
  top: '100%',
  left: 0,
  zIndex: 30,
  width: 'max(100%, 400px)',
  marginTop: 6,
  padding: 4,
  background: '#fff',
  border: '1px solid #E3E3E3',
  borderRadius: 10,
  boxShadow: '0 8px 24px rgba(5, 20, 31, 0.14)',
};
const row = {
  display: 'flex',
  gap: 12,
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 10px',
  borderRadius: 8,
};
const pick = {
  flexShrink: 0,
  padding: '4px 12px',
  fontSize: 13,
  color: 'var(--brand-primary)',
  background: 'transparent',
  border: '1px solid var(--brand-primary)',
  borderRadius: 6,
  cursor: 'pointer',
};

const describe = (car) => [carSummary(car), car.price ? `${formatNumber(car.price)} â¸` : ''].filter(Boolean).join(' Â· ');

/**
 * ÐÐ¾Ð»Ðµ VIN Ñ Ð¿Ð¾Ð¸ÑÐºÐ¾Ð¼ ÑÐ¶Ðµ Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½ÑÑ Ð¼Ð°ÑÐ¸Ð½: Ð¿Ð¾ÐºÐ° Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð²Ð²Ð¾Ð´Ð¸Ñ Ð½Ð¾Ð¼ÐµÑ, Ð½Ð¸Ð¶Ðµ Ð¿Ð¾ÑÐ²Ð»ÑÐµÑÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ð¹
 * (Ð¿Ð¾ Ð»ÑÐ±Ð¾Ð¹ ÑÐ°ÑÑÐ¸ VIN, Ð¾Ñ Ð¿ÑÑÐ¸ Ð·Ð½Ð°ÐºÐ¾Ð²) Ñ ÐºÐ½Ð¾Ð¿ÐºÐ¾Ð¹ Â«ÐÑÐ±ÑÐ°ÑÑÂ» â Ð²ÑÐ¾ÑÑÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ Ð½Ð° ÑÑ Ð¶Ðµ Ð¼Ð°ÑÐ¸Ð½Ñ Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑ Ð½Ðµ Ð½ÑÐ¶Ð½Ð¾.
 * Ð¡Ð¿Ð¸ÑÐ¾Ðº Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑÑÑ Ð¿Ð¾ Esc Ð¸ Ð¿Ð¾ ÐºÐ»Ð¸ÐºÑ Ð¼Ð¸Ð¼Ð¾; Ð´Ð°Ð»ÑÐ½ÐµÐ¹ÑÐ¸Ð¹ Ð²Ð²Ð¾Ð´ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ ÐµÐ³Ð¾ ÑÐ½Ð¾Ð²Ð°.
 */
const VinInput = ({ onPickCar, component, ...props }) => {
  const [cars, setCars] = useState([]);
  const [closed, setClosed] = useState(false);
  const [hovered, setHovered] = useState(null);
  const wrapper = useRef(null);
  const query = vinSearchQuery(props.value);

  useEffect(() => setClosed(false), [query]);

  useEffect(() => {
    if (!query) {
      setCars([]);
      return undefined;
    }
    let cancelled = false;
    const timer = setTimeout(() => {
      findByVin(query)
        .then((res) => {
          if (!cancelled) setCars(Array.isArray(res?.data) ? res.data : []);
        })
        .catch(() => {
          if (!cancelled) setCars([]);
        });
    }, SEARCH_DELAY_MS);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query]);

  const visible = cars.length > 0 && !closed;
  useEffect(() => {
    if (!visible) return undefined;
    const onDown = (event) => {
      if (wrapper.current && !wrapper.current.contains(event.target)) setClosed(true);
    };
    const onKey = (event) => event.key === 'Escape' && setClosed(true);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [visible]);

  return (
    <div style={{ position: 'relative' }} ref={wrapper}>
      <Input {...props} />
      {visible && (
        <div style={box}>
          {cars.map((car) => (
            <div
              key={car.id}
              style={{
                ...row,
                // ÐÐ¾Ð»Ð½Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ VIN Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¸Ð²Ð°ÐµÐ¼: Ð¼Ð°ÑÐ¸Ð½Ð° ÑÐ¾ÑÐ½Ð¾ ÑÐ¶Ðµ Ð·Ð°Ð²ÐµÐ´ÐµÐ½Ð°.
                background: isSameVin(car, props.value) ? '#EAF5EC' : hovered === car.id ? '#F5F2EC' : 'transparent',
              }}
              onMouseEnter={() => setHovered(car.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, letterSpacing: 0.3 }}>{car.vin}</div>
                <div style={{ fontSize: 12, color: '#8B8B8B', marginTop: 2 }}>{describe(car) || 'Ð±ÐµÐ· Ð¾Ð¿Ð¸ÑÐ°Ð½Ð¸Ñ'}</div>
              </div>
              <button type="button" style={pick} onClick={() => onPickCar && onPickCar(car)}>
                ÐÑÐ±ÑÐ°ÑÑ
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VinInput;
